import React from "react";
import { Layout } from "antd";
import HorizontalDark from "../containers/Topbar/HorizontalDark";
import TopBar from "../components/TopBar/TopBar";
import Sidebar from "../containers/Sidebar";
import SiteFooter from "../components/Buyer/FooterComponent/SiteFooter";

const { Content } = Layout;

const ResolutionCenterLayout = (ViewComponent) => {
  return class extends React.Component {
    render() {
      return (
        <Layout className="gx-app-layout">
          <Sidebar />
          <Layout>
            <TopBar />
            <HorizontalDark />
            <Content>
              <>
                <ViewComponent />
              </>
              <SiteFooter />
            </Content>
          </Layout>
        </Layout>
      );
    }
  };
};

export default ResolutionCenterLayout;
